import { Col, InputNumber, Row, Slider, Tooltip } from 'antd';
import React, { useMemo, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';

import gameModes from '../../enums/modes';
import { setCurrentGame } from '../../redux/actions/game';
import { resetLastResult } from '../../redux/actions/result';
import { RADIUS_DESCRIPTION } from '../../util';
import BattleLinkModal from '../BattleLinkModal';
import { GameStartButtons } from '../GameStartButtons';
import { SinglePlayerModal } from '../SinglePlayerModal';
import { SuggestInput } from '../SuggestInput';

export const CustomPlace = ({ multiplayerSupported }) => {
    const dispatch = useDispatch();
    const [selectedPlaceData, setSelectedPlaceData] = useState(null);
    const [radius, setRadius] = useState(1);
    const [battleModalVisible, setBattleModalVisible] = useState(false);
    const [playGame, setPlayGame] = useState(false);
    const [singlePlayerModalVisible, setSinglePlayerModalVisible] = useState(false);

    const handleSinglePlayerModalVisibility = isVisible => {
        setSinglePlayerModalVisible(isVisible);
    };

    const handleBattleModalVisibility = isVisible => {
        setBattleModalVisible(isVisible);
    };

    const handleClickStartGame = (resultMode, noMove = false) => {
        dispatch(resetLastResult());
        dispatch(
            setCurrentGame({
                mode: gameModes.custom,
                round: 1,
                totalScore: 0,
                radius: Number(radius),
                city: cityData,
                guessResultMode: resultMode,
                regionNutCode: null,
                noMove,
            }),
        );
        setPlayGame(true);
    };

    const handleChangeRadius = value => {
        setRadius(value);
    };

    // Handler pro nové SuggestInput API
    const handleSuggestSelect = useCallback((item) => {
        setSelectedPlaceData({
            data: {
                latitude: item.latitude,
                longitude: item.longitude,
                title: item.name,
                secondRow: item.location,
            },
        });
    }, []);

    const cityData = useMemo(() => {
        return {
            coordinates: {
                latitude: selectedPlaceData?.data?.latitude,
                longitude: selectedPlaceData?.data?.longitude,
            },
            place: selectedPlaceData?.data?.title,
            info: selectedPlaceData?.data?.secondRow,
        };
    }, [selectedPlaceData]);

    if (playGame) {
        return (
            <Redirect
                to={{
                    pathname: '/vlastni',
                }}
            />
        );
    }

    return (
        <div className="customPlaceForm">
            <SuggestInput
                placeholder="Místo, které chceš zkoumat"
                onSelect={handleSuggestSelect}
                className="ant-input text-input"
            />
            <label htmlFor="radius">
                <Tooltip title={RADIUS_DESCRIPTION}>
                    <span>Radius (km):</span>
                </Tooltip>
            </label>
            <Row>
                <Col span={12} style={{ paddingLeft: 6, paddingRight: 6 }}>
                    <Slider
                        min={1}
                        max={10}
                        onChange={handleChangeRadius}
                        value={typeof radius === 'number' ? radius : 0}
                    />
                </Col>
                <Col span={4}>
                    <InputNumber
                        size="large"
                        min={1}
                        max={10}
                        style={{ marginLeft: 16 }}
                        value={radius}
                        onChange={handleChangeRadius}
                    />
                </Col>
            </Row>
            <p style={{ marginTop: '10px', fontSize: '13px', color: '#8c8c8c' }}>
                Panoramata budou náhodně generována v okolí {radius} km od vámi vybraného místa.
            </p>
            {selectedPlaceData && (
                <GameStartButtons
                    isMultiplayerSupported={multiplayerSupported}
                    onSinglePlayerModalVisible={handleSinglePlayerModalVisibility}
                    onBattleModalVisible={handleBattleModalVisibility}
                />
            )}
            <SinglePlayerModal
                visible={singlePlayerModalVisible}
                onModalVisibility={handleSinglePlayerModalVisibility}
                onClickStartGame={handleClickStartGame}
            />
            <BattleLinkModal
                visible={battleModalVisible}
                handleBattleModalVisibility={handleBattleModalVisibility}
                mode={gameModes.custom}
                radius={Number(radius)}
                selectedCity={cityData}
            />
        </div>
    );
};
